import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCheck } from "@fortawesome/free-solid-svg-icons";

import { Context } from "../backend/context";
import { Redirect } from "react-router";

export default function Auth() {
  const { signIn, authError, isLoggedIn, user } = React.useContext(Context);

  return (
    <div className="container-fluid pt-5 badge-dark">
      {isLoggedIn && user ? <Redirect to="/account" /> : null}
      <div className="container-fluid h-50 text-center">
        <div className="row">
          <div
            className="col-12 text-center h2 pb-3"
            style={{ color: "white" }}
          >
            Nash TradingBot
          </div>
        </div>
        <div className="row">
          <div
            className="col-12 col-sm-8 m-auto text-center pb-3"
            style={{ color: "white" }}
          >
            Cloud-based automated trading bots for{" "}
            <a
              style={{ textDecoration: "none" }}
              target="_blank"
              href="https://app.nash.io/trade/exchange/advanced?code=2ty1Z4"
            >
              Nash.io
            </a>{" "}
            exchange. Create your first bot within a few minutes and let it to
            trade 24/7 for you.
          </div>
        </div>
        <div className="row">
          <div
            className="col-12 col-md-6 m-auto py-4 badge-dark "
            style={{ borderRadius: 30, backgroundColor: "black" }}
          >
            <div className="row">
              <div className="col-12 text-center card-title h3">Sign In</div>
              <div className="col-12">
                {authError && (
                  <div className="row py-3">
                    <div className="col-12">
                      <div className="alert alert-danger m-auto py-1">
                        {authError}
                      </div>
                    </div>
                  </div>
                )}

                <div className="row py-3">
                  <div className="col-12">
                    <button
                      onClick={() => signIn()}
                      type="button"
                      className="btn btn-danger w-50"
                      style={{ borderRadius: 20 }}
                    >
                      <FontAwesomeIcon
                        icon={["fab", "google"]}
                        style={{ marginRight: 10 }}
                      />
                      Sign In With Google
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
